module.exports = __webpack_public_path__ + "img/france-mental-and-behavioural-disorders-male.fa6041c4.png";